module.exports = __webpack_public_path__ + "img/notice.56dc463d.png";